import { render, staticRenderFns } from "./cpt-chart-pie.vue?vue&type=template&id=0fed9561&scoped=true"
import script from "./cpt-chart-pie.vue?vue&type=script&lang=js"
export * from "./cpt-chart-pie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fed9561",
  null
  
)

export default component.exports